class MedicalHistoryGeneticHistoryOfGametes {
    // Ethnic/Racial Background
    public EthnicRacialBackgroundOfEggDonor: string;
    public EggDonorAgeYears?: number;
    public EthicRacialBackgroundOfSpermDonor: string;

    // Carrier Screening Section
    public IsCarrierAtRisk?: boolean;
    public HemoglobinopathyScreening?: boolean;
    public TaySachsDiseaseScreening?: boolean;
    public AshkenaziJewishScreeningPanel?: boolean;

    // Genetic Family History Section
    public FamilyGeneticConditions?: boolean;
    public OtherGeneticFamilyHistory?: boolean;
    public Consanguinity?: boolean;

    constructor(fields?: Partial<MedicalHistoryGeneticHistoryOfGametes>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.IsCarrierAtRisk = this.IsCarrierAtRisk || false;
        this.HemoglobinopathyScreening = this.HemoglobinopathyScreening || false;
        this.TaySachsDiseaseScreening = this.TaySachsDiseaseScreening || false;
        this.AshkenaziJewishScreeningPanel = this.AshkenaziJewishScreeningPanel || false;
        this.FamilyGeneticConditions = this.FamilyGeneticConditions || false;
        this.OtherGeneticFamilyHistory = this.OtherGeneticFamilyHistory || false;
        this.Consanguinity = this.Consanguinity || false;
    }
}

export { MedicalHistoryGeneticHistoryOfGametes };
